import { template, className, regions } from "core/decorators";
import { LayoutView } from "marionette";
import App from "app";
import SchemaSelectionTemplate from "./templates/schema-selection.template.html";
import "datatables.net-dt";
import "datatables.net-select-dt";
import stringUtils from "core/utils/string-utils";
import InlineHelpMarionetteContainer from "../inline-help-container";
import TableWrapperSelection from "./source-wizard-react-view/table-wrapper-selection/table-wrapper-selection";
import MarionetteWrapper from "../../../../../marionette-wrapper-for-react";
import _ from "underscore";

@className("card schema-selection-view")
@template(SchemaSelectionTemplate)
@regions({
    schemaSelection: "#table-wrapper-selection-react-container"
})
export default class SchemaSelectionView extends InlineHelpMarionetteContainer {
    initialize() {
        let model = App.reqres.request("get:wizard:model");
        this.model = model;
    }

    onRender() {
        const ChannelSelectionReactView = MarionetteWrapper(TableWrapperSelection, {
            schemas: this.model.get("channels").models,
            whatIsInside: this.model.get("whatsInside"),
            isChannel: true,
            model: this.model
        });

        this.getRegion("schemaSelection").show(ChannelSelectionReactView);
    }

    onShow() {}

    async canMoveForward() {
        App.vent.trigger("appwizard:retry:hide");
        App.vent.trigger("appwizard:next:enable");
    }

    onBeforeDestroy() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
}
